import React, { HTMLAttributes, useState } from 'react'
import { Link } from 'gatsby'
import Headroom from 'react-headroom'

import { useContactInfo } from '../hooks/useContactInfo'
import { Container } from './Container'
import { IconPhone } from './Icons'
import { LinkButton } from './LinkButton'
import { Logo } from './Logo'
import { Menu } from './Menu'
import { MenuToggle } from './MenuToggle'

export interface HeaderProps extends HTMLAttributes<HTMLElement> {}

export const Header = ({}: HeaderProps) => {
  const [isOpen, setOpen] = useState<boolean>(false)
  const { basicContact } = useContactInfo()
  const phone = basicContact?.phone

  return (
    <Headroom className="relative z-20">
      <header className="py-8 bg-white z-20">
        <Container>
          <div className="grid gap-8 grid-cols-[1fr,auto] md:flex items-center justify-between">
            <Link to="/">
              <Logo />
            </Link>

            <div className="block md:hidden">
              <MenuToggle onClick={() => setOpen(!isOpen)} />
            </div>

            <div
              className={`mt-8 md:mt-0 gap-8 col-span-2 ${
                isOpen
                  ? 'grid items-center content-center justify-center gap-4'
                  : 'hidden'
              } md:flex md:gap-4 lg:gap-16`}
            >
              <Menu />

              {phone && (
                <LinkButton
                  className="button--primary"
                  href={`tel:+420${phone.replace(/ /gi, '')}`}
                >
                  <IconPhone />
                  {phone}
                </LinkButton>
              )}
            </div>
          </div>
        </Container>
      </header>
    </Headroom>
  )
}
